import { render } from "./MediaPress.vue?vue&type=template&id=782eb44c"
import script from "./MediaPress.vue?vue&type=script&lang=js"
export * from "./MediaPress.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__